<template>
  <div class="wrap">

    <l-dialog
      :show="showReg"
      class="reglog"
      :ischa="true"
      @cancel="showReg=false"
      @save="reg()"
      title="注册账号"
    >
      <div class="ipt">
        <span class="label">
          <span>*</span>账号：
        </span>
        <el-input v-model="acount" style="width:2.4rem"></el-input>
        <span style="color:#999999;font-size:.14rem">（字母+数字组成）</span>
      </div>
      <div class="ipt">
        <span class="label">
          <span>*</span>密码：
        </span>
        <el-input v-model="regpwd" style="width:2.4rem" type="password"></el-input>
        <span style="color:#999999;font-size:.14rem">（密码长度不超过16位）</span>
      </div>
      <div class="ipt">
        <span class="label">
          <span>*</span>真实姓名：
        </span>
        <el-input v-model="name" style="width:2.4rem"></el-input>

        <span class="label" style="margin-left:.2rem;width:.7rem">
          <span>*</span>性别：
        </span>
        <el-select v-model="sex" placeholder="请选择" style="width:1rem">
          <el-option value="男"></el-option>
          <el-option value="女"></el-option>
        </el-select>

      </div>
      <div class="ipt">
        <span class="label">
          <span>*</span>所在部门：
        </span>
        <el-select v-model="grade" placeholder="请选择" style="width:2.4rem">
          <el-option
            v-for="(item,index) in classList"
            :key="index"
            :label="item.deptname"
            :value="item.deptid"
          ></el-option>
        </el-select>

        <span class="label" style="margin-left:.2rem;width:.7rem">
          <span>*</span>编号：
        </span>
        <el-input v-model="userId" @input="userId=userId.replace(/[^0-9]/g, '')" style="width:1rem"></el-input>
      </div>
    </l-dialog>
    <l-dialog
      :show="showFind"
      class="findlog"
      :ischa="true"
      @cancel="showFind=false"
      @save="findPwd()"
      title="找回密码"
      val1="确定"
    >
      <div class="ipts">
        <div class="ipt">
          <span class="label">
            <span>*</span>要找回的账号：
          </span>
          <el-input v-model="findAcount" style="width:3rem"></el-input>
        </div>
        <div class="ipt">
          <span class="label">
            <span>*</span>所在部门：
          </span>
          <el-select v-model="grade" placeholder="请选择" style="width:3rem">
            <el-option
              v-for="(item,index) in classList"
              :key="index"
              :label="item.deptname"
              :value="item.deptid"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="ipt">
        <span class="label">
          <span>*</span>申请找回密码的原因：
        </span>
        <el-input v-model="findMsg" style="width:6.2rem" type="textarea"></el-input>
      </div>
    </l-dialog>
    <div class="bg">
      <img class="left" src="../../assets/img/login/left.gif" alt />
      <img class="right" src="../../assets/img/login/right.gif" alt />
      <div class="topNav" style="-webkit-app-region: drag;">
        <img
          :src="logo ? global.ip+logo : require('../../assets/img/login/logo.png')"
          alt
          class="logo"
        />
        <span class="logtit">{{$store.state.sysTitle}}</span>
        <div class="oper">
          <span @click="showReg = true,getClass()" style="-webkit-app-region:no-drag">
            <img src="../../assets/img/login/reg.png" alt />注册账号
          </span>
          <span @click="showFind = true,getClass()" style="-webkit-app-region:no-drag">
            <img src="../../assets/img/login/res.png" alt />找回密码
          </span>
          <span @click="offSys()" style="-webkit-app-region:no-drag">
            <img src="../../assets/img/login/logout.png" alt /> 退出程序
          </span>
        </div>
      </div>
      <div class="box">
        <!-- <img :src="codeImg" alt class="codeImg" @click="isBigCode=!isBigCode" v-if="isCode" />
        <div class="bigcode" v-show="isBigCode">
          <div class="past" v-show="isLogoCodeTime">二维码已过期</div>
          <img :src="codeImg" alt class="bigCodeImg" />
          <p>扫描二维码登录</p>
        </div> -->
        <!-- <img class="title" src="../../assets/img/login/title.png" alt /> -->
        <p class="title">{{$store.state.sysTitle}}</p>
        <input type="text" class="user ipt" placeholder="请输入您的账号" v-model="user" />
        <input type="password" class="pwd ipt" placeholder="请输入您的密码" v-model="pwd" />
        <p class="auto">
          <input type="checkbox" v-model="isauto" />
          <span>下次自动登录</span>
        </p>
        <button class="login" @click="login">登录</button>
      </div>
    </div>
    <p
      class="footer"
    >2016-{{new Date().getFullYear()}} All Rights Reserved . {{$store.state.sysTitle}}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: "",
      pwd: "",
      isCode: false,
      codeImg: "",
      isauto: false,
      isBigCode: false,
      sysTitle: "",
      logo: "",
      //注册
      classList: [],
      showReg: false,
      acount: "",
      regpwd: "",
      name: "",
      grade: "",
      sex: "男",
      userId: "",
      //找回密码
      showFind: false,
      findAcount: "",
      findMsg: "",
    };
  },
  methods: {
    //退出
    offSys() {
      this.$popup({
        title: '提示',
        content: '确定要退出本系统？',
        saveFoo: () => {
          if ('FingerprintObj' in window) {
            FingerprintObj.closeWindow()
          } else {
            this.$myMessage('当前状态下，没有此功能！')
          }
        },
      })
    },
    //获取logo
    async getLogoInfo() {
      let { data } = await this.$post("api/system/company/info", {
        status: 1,
      });
      this.logo = data.data.list.logo;
      this.$store.commit("setLogo", this.logo);
      this.$store.commit("setGreet", data.data.list.greet);
    },
    //获取系统信息
    async getSystemInfo() {
      let { data } = await this.$post("api/system/config/info", {
        status: 1,
      }, {noStopRepeat: true});
      this.sysTitle = data.data.list.systemtitle;
      let codeTime = [
        data.data.list.qrcode_login_startdate,
        data.data.list.qrcode_login_enddate,
      ];
      let testTime = [
        data.data.list.qrcode_test_startdate,
        data.data.list.qrcode_test_enddate,
      ];
      this.isCode = Boolean(data.data.list.can_qrcode_login);
      this.$store.commit("setSysTitle", data.data.list.systemtitle);

      let twoCodeLogin = data.data.list.can_qrcode_login == 1 ? true : false;
      let scanQRCodes = data.data.list.can_qrcode_test == 1 ? true : false;
      this.$store.commit("setCode", {
        logo: codeTime, 
        isLogo: twoCodeLogin, 
        test: testTime, 
        isTest: scanQRCodes,
      });
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        this.isauto = true;
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.user = arr2[1];
          } else if (arr2[0] == "userPwd") {
            this.pwd = arr2[1];
          }
        }
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
    //登录
    async login() {
      let { data } = await this.$post("api/index/login", {
        username: this.user,
        pwd: this.pwd,
      });
      if (data.code == 0) {
        //保存账号密码
        if (this.isauto) {
          this.setCookie(this.user, this.pwd, 7);
        } else {
          this.clearCookie();
        }
        localStorage.setItem("userinfo", JSON.stringify(data.data.list));
        this.$router.push("/");
      }
    },
    //获取登录二维码
    async getLgoinCode() {
      let cip = "";
      try {
        cip = `http://${/([0-9]{1,3}(\.[0-9]{1,3}){3})/.exec(FingerprintObj.getLocalIp())[0]}`;
      } catch (error) {
        cip = this.global.ip.replace(/:[0-9]+/, '');
      }
      let { data } = await this.$post("api/system/QR/getLoginQR", {
        lanIP: cip,
        type: 1,
        status: 1,
      });
      this.codeImg = data.data.list.qr.thumb;
    },
    //获取部门
    async getClass() {
      let { data } = await this.$post("api/msg/dept", {});
      this.classList = data.data.list;
    },
    //注册
    reg() {
      if (
        !this.acount ||
        !this.regpwd ||
        !this.name ||
        !this.grade ||
        !this.sex ||
        !this.userId
      ) {
        this.$myMessage("请填写所有必填项 !");
        return;
      }
      this.$post("api/index/register", {
        username: this.acount,
        pwd: this.regpwd,
        nickname: this.name,
        sex: this.sex,
        deptid: this.grade,
        studentId: this.userId,
        status: 1,
      }).then(({data})=>{
        if (data.code == 0) {
          this.showReg = false;
          this.acount = "";
          this.regpwd = "";
          this.name = "";
          this.grade = "";
          this.userId = "";
        }
      })
    },
    findPwd() {
      if (!this.findAcount) {
        this.$myMessage('账号不能为空')
        return
      }
      if (!this.grade) {
        this.$myMessage('请选择部门')
        return
      }
      if (!this.findMsg) {
        this.$myMessage('原因不能为空')
        return
      }
      this.$post("api/index/appeal", {
        username: this.findAcount,
        deptid: this.grade,
        reason: this.findMsg,
      }).then((res) => {
        if (res.data.code == '0') {
          this.findAcount = ''
          this.grade = ''
          this.findMsg = ''
          this.showFind = false;
        }
      })
    },
  },
  computed: {
    isLogoCodeTime() {
      if (!this.$store.state.logoCode) {
        return true
      }
      let starttime = this.$store.state.logoCodeTime[0];
      let endtime = this.$store.state.logoCodeTime[1];
      if (
        +new Date(starttime) > +new Date() ||
        +new Date(endtime) < +new Date()
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getLgoinCode();
    this.getCookie();
    this.getLogoInfo();
    this.getSystemInfo();
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background: #f0f0f0;
  height: 10.8rem;
  //对话框
  /deep/.reglog .dialog {
    width: 800px;
    height: 480px;
    z-index: 9;
    .content {
      padding: 40px 0 0 137px;
      .el-input__inner {
        background: #f0f0f0;
        border: 0;
      }
      .ipt {
        margin-bottom: 30px;
        .label {
          display: inline-block;
          width: 100px;
          span {
            color: red;
          }
        }
      }
      .btn {
        margin-left: -137px;
      }
    }
  }

  /deep/.findlog .dialog {
    width: 800px;
    height: 480px;
    z-index: 9;
    .content {
      padding: 40px 89px 0 89px;
      .el-input__inner,
      .el-textarea__inner {
        background: #f0f0f0;
        border: 0;
      }
      .el-textarea__inner {
        height: 100px;
        resize: none;
      }
      .ipts {
        display: flex;
        justify-content: space-between;
      }
      .ipt {
        margin-bottom: 30px;
        width: 300px;
        .label {
          display: inline-block;
          width: 200px;
          margin-bottom: 19px;
          span {
            color: red;
          }
        }
      }
    }
  }
  .bg {
    height: 370px;
    background-image: url("../../assets/img/login/bg.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: relative;
    //margin-top: 220px;
    .left {
      position: absolute;
      bottom: 0;
      height: 258px;
      left: 118px;
    }
    .right {
      position: absolute;
      bottom: 0;
      height: 252px;
      right: 253px;
    }
    .topNav {
      margin-bottom: 220px;
      display: flex;
      color: rgba(255, 255, 255, 0.8);
      padding-top: 30px;
      .logo {
        height: 24px;
        width: 70px;
        margin: 0 10px 0 30px;
      }
      .logtit {
        &::before {
          content: "";
          height: 20px;
          border-right: 1px solid rgba(255, 255, 255, 0.8);
          margin: 0 10px;
        }
      }
      .oper {
        margin-left: 1210px;
        position: relative;
        z-index: 9999999;
        img {
          height: 16px;
          margin-right: 10px;
        }
        span {
          position: relative;
          z-index: 9999;
          &::after {
            content: "";
            height: 20px;
            border-right: 1px solid rgba(255, 255, 255, 0.8);
            margin: 0 20px 0 30px;
          }
          &:last-child {
            &::after {
              display: none;
            }
          }
        }
      }
    }
    .box {
      position: relative;
      overflow: hidden;
      height: 480px;
      width: 450px;
      background: #fff;
      margin: 0 auto;
      text-align: center;
      border-radius: 10px;
      box-shadow: 0px 0px 10px 0px rgba(13, 4, 9, 0.2);
      .codeImg {
        position: absolute;
        height: 60px;
        right: -30px;
        top: -30px;
      }
      .bigcode {
        position: absolute;
        top: 50px;
        left: 30px;
        height: 400px;
        width: 400px;
        background: #fff;
        z-index: 99;
        padding-top: 20px;
        .past {
          box-sizing: border-box;
          position: absolute;
          background: rgba(255, 255, 255, 0.8);
          height: 400px;
          width: 400px;
          font-size: 32px;
          padding-top: 120px;
          font-weight: bold;
        }
      }
      .bigCodeImg {
        height: 300px;
      }
      .title {
        height: 29px;
        color: #004eff;
        font-size: 32px;
        font-weight: 600;
        margin: 53px 0 58px 0;
      }
      .ipt {
        width: 340px;
        height: 44px;
        background-color: #f0f0f0;
        border: 0;
        outline: none;
        border-radius: 4px;
        padding-left: 50px;
        box-sizing: border-box;
        background-repeat: no-repeat;
        background-size: 18px 20px;
        margin-bottom: 30px;
      }
      .user {
        background-image: url("../../assets/img/login/user.png");
        background-position: 15px 11px;
      }
      .pwd {
        background-image: url("../../assets/img/login/pwd.png");
        background-position: 15px 11px;
      }
      .auto {
        text-align: left;
        margin-left: 65px;
        color: #555555;
        font-size: 14px;
        position: relative;
        input {
          position: absolute;
          top: 2px;
        }
        span {
          margin-left: 20px;
        }
      }
      .login {
        background: #004eff;
        color: #fff;
        height: 44px;
        width: 340px;
        border: 0;
        border-radius: 4px;
        margin-top: 73px;
      }
    }
  }
  .footer {
    margin-top: 654px;
    text-align: center;
    color: #999999;
  }
}
</style>